<template>
  <div>
    <b-collapse
      v-if="!isFilterLoading && !shouldFetchMoreRecords"
      class="card show"
      animation="slide"
      aria-id="contentIdForA11y3"
      :open="filterApplicationsOpen"
      @open="toggleFilterApplications(true)"
      @close="toggleFilterApplications(false)"
    >
      <template #trigger="props">
        <div
          class="card-header"
          role="button"
          aria-controls="contentIdForA11y3"
          :aria-expanded="props.open"
        >
          <p class="card-header-title">Filter applications</p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"> </b-icon>
          </a>
        </div>
      </template>

      <div class="card-content filter-columns">
        <div class="columns">
          <div class="column is-half">
            <b-field label="Application time">
              <b-select
                placeholder="Display applications that changed in the last:"
                v-model="filter.time"
                expanded
              >
                <option value="1">24 hours</option>
                <option value="2">48 hours</option>
                <option value="7">week</option>
                <option value="30">month</option>
              </b-select>
            </b-field>

            <b-field label="Intake">
              <multiselect
                v-model="filter.intake"
                :options="filterOptions.intake"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
              </multiselect>
            </b-field>

            <b-field label="Status">
              <multiselect
                v-model="filter.status"
                :options="filterOptions.status"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
                <template slot="tag" slot-scope="{ option, remove }">
                  <span :class="getRowClass(option.value, false)">
                    <span>{{ option.value }}</span>
                    <span class="multiselect__tag-icon" @click="remove(option)">
                    </span>
                  </span>
                </template>
              </multiselect>
            </b-field>

            <b-field label="Student name">
              <multiselect
                v-model="filter.student"
                :options="filterOptions.student"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
                :taggable="true"
                @tag="addTagStudent"
              >
                <template slot="option" slot-scope="{ option }">
                  <div v-if="option.value" class="media">
                    <div class="media-content">
                      {{ option.value }}
                      <br />
                    </div>
                  </div>
                </template>
              </multiselect>
            </b-field>

            <b-field label="University">
              <multiselect
                v-model="filter.university"
                placeholder="Search or add a tag"
                tag-placeholder="Add this as new tag"
                tag-position="top"
                track-by="title"
                label="title"
                :options="filterOptions.universities"
                :multiple="true"
                :taggable="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                :preselect-first="false"
                @tag="addTagUniversityTitle"
              >
                <template slot="option" slot-scope="{ option }">
                  <div v-if="option.id" class="media">
                    <div class="media-left">
                      <img width="32" :src="option.img_url" />
                    </div>
                    <div class="media-content">
                      {{ option.title }}
                      <br />
                      <small> Address: {{ option.address }} </small>
                      <br />
                    </div>
                  </div>
                </template>
              </multiselect>
            </b-field>

            <b-field label="University campus">
              <multiselect
                v-model="filter.address"
                placeholder="Search or add a tag"
                tag-placeholder="Add this as new tag"
                track-by="address"
                label="address"
                :options="filteredAddressArray"
                :multiple="true"
                :taggable="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                :preselect-first="false"
                @tag="addTagUniversityAdress"
              >
                <template slot="option" slot-scope="{ option }">
                  <div v-if="option.id" class="media">
                    <div class="media-left">
                      <img width="32" :src="option.img_url" />
                    </div>
                    <div class="media-content">
                      {{ option.title }}
                      <br />
                      <small> Address: {{ option.address }} </small>
                      <br />
                    </div>
                  </div>
                </template>
              </multiselect>
            </b-field>

            <b-field label="SFE">
              <multiselect
                v-model="filter.sfe"
                :options="filterOptions.sfe"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
              </multiselect>
            </b-field>

            <b-field v-if="hasEditingRole || shouldSeeApprove" label="Admins">
              <multiselect
                v-model="filter.admins"
                :options="filterOptions.admins"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
              </multiselect>
            </b-field>

            <b-field
              v-if="hasEditingRole || shouldSeeApprove"
              label="Filter by team position"
            >
              <div class="block">
                <b-radio
                  v-model="filter.teamLeaderOnly"
                  name="name"
                  :native-value="false"
                >
                  All
                </b-radio>
                <b-radio
                  v-model="filter.teamLeaderOnly"
                  name="name"
                  native-value="teamLeader"
                >
                  Team Leader
                </b-radio>
                <b-radio
                  v-model="filter.teamLeaderOnly"
                  name="name"
                  native-value="agent"
                >
                  Agent
                </b-radio>
              </div>
            </b-field>

            <b-field v-if="hasEditingRole || shouldSeeApprove" label="">
              <b-checkbox v-model="filter.deletedAgents">
                Show only deleted agents
              </b-checkbox>
            </b-field>
          </div>

          <div class="column is-half">
            <b-field label="Agents">
              <multiselect
                v-model="filter.moderator"
                :options="filterOptions.moderator"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
              </multiselect>
            </b-field>

            <b-field label="Course">
              <multiselect
                v-model="filter.course"
                :options="filterOptions.course"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
                :taggable="true"
                @tag="addTagCourse"
              >
                <template slot="option" slot-scope="{ option }">
                  <div v-if="option.value" class="media">
                    <div class="media-content">
                      {{ option.value }}
                      <br />
                    </div>
                  </div>
                </template>
              </multiselect>
            </b-field>

            <b-field label="Booking">
              <multiselect
                v-model="filter.booking"
                :options="filterOptions.booking"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
              </multiselect>
            </b-field>

            <b-field v-if="hasEditingRole || shouldSeeApprove" label="Teams">
              <multiselect
                v-model="filter.teams"
                :options="filterOptions.teams"
                track-by="teamId"
                label="username"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
                <template slot="option" slot-scope="{ option }">
                  <span class="">{{ parseTeam(option) }}</span>
                </template>
              </multiselect>
            </b-field>

            <b-field label="English test">
              <multiselect
                v-model="filter.english_test"
                @select="checkIfCustom($event, 'english_test')"
                :options="filterOptions.english_test"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
              </multiselect>
            </b-field>

            <b-field label="Interview">
              <multiselect
                v-model="filter.interview"
                @select="checkIfCustom($event, 'interview')"
                :options="filterOptions.interview"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
              </multiselect>
            </b-field>

            <b-field label="Student Id">
              <multiselect
                v-model="filter.studentId"
                :options="filterOptions.studentIds"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
              </multiselect>
            </b-field>

            <b-field label="How did you find this student?">
              <multiselect
                v-model="filter.student_referal"
                :options="filterOptions.student_referal"
                track-by="value"
                label="value"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Choose a filter option"
                :preselect-first="false"
              >
              </multiselect>
            </b-field>

            <div class="field">
              <label class="label"> Timetable Options / Delivery: </label>
              <b-checkbox
                v-for="(timetable, index) in filterOptions.timetable"
                v-bind:key="index"
                v-model="filter.timetable"
                :native-value="timetable"
              >
                {{ timetable }}
              </b-checkbox>
            </div>

            <div class="field">
              <b-field label="Students per page">
                <b-select v-model="filterPerPage">
                  <option
                    v-for="option in filterPerPageOptions"
                    :value="option.value"
                    :key="option.value"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
            </div>

            <b-field label="Not approved">
              <b-checkbox v-model="filter.needsApproval">
                Show only unapproved apps
              </b-checkbox>
            </b-field>
          </div>

          <div class="block column is-full">
            <b-button type="is-primary" @click="resetQuery"
              >Reset search</b-button
            >
            <b-button
              type="is-primary"
              style="margin-left: 15px"
              @click="regenerateFilters"
              >Regen filters</b-button
            >

            <b-button v-if="isAdmin" class="ml-2" @click="downloadData"
              >Download all student data</b-button
            >

            <b-button
              v-if="hasEditingRole"
              class="ml-2"
              @click="downloadLocalData"
              >Download local student data</b-button
            >

            <b-button
              v-if="hasEditingRole"
              style="margin-left: 15px"
              @click="isStudentAdvisorChangeModalActive = true"
              >Change student advisor</b-button
            >

            <b-dropdown
              v-model="oldStudentIntake"
              aria-role="list"
              v-if="hasEditingRole"
              style="margin-left: 15px"
            >
              <template #trigger="{ active }">
                <b-button
                  :label="
                    oldStudentIntake
                      ? `Move Students to intake ${oldStudentIntake}`
                      : 'Move Students to old intake'
                  "
                  type="is-primary"
                  :icon-right="active ? 'menu-up' : 'menu-down'"
                />
              </template>
              <b-dropdown-item
                v-for="intake in changeStudentIntakeOptions"
                :key="intake.value"
                :value="intake.value"
                aria-role="listitem"
                >{{ intake.value }}</b-dropdown-item
              >
            </b-dropdown>
            <b-icon
              v-if="oldStudentIntake"
              icon="send-check"
              class="cursor-pointer mt-1 ml-1"
              type="is-success"
              @click.native.prevent="moveStudentsToOldIntake"
            ></b-icon>
          </div>
        </div>
      </div>
    </b-collapse>

    <student-loader v-else :finishedLoading="shouldFetchMoreRecords" />

    <section v-if="!isFilterLoading" class="card-content">
      <div class="card-header">
        <h3 class="card-header-title">Previously saved filters</h3>
        <b-button type="is-success" @click="saveQuery">Save filters</b-button>
      </div>
      <div v-if="savedQueries.length > 0" class="card-content d-flex">
        <b-field
          v-for="(value, i) in savedQueries"
          :key="i"
          :value="value"
          @click.native.prevent="setSavedFilter(value)"
        >
          <b-tag
            style="cursor: pointer; margin-right: 12px"
            :type="isTagSelected(value.name)"
            closable
            aria-close-label="Close tag"
            @close="deleteSavedQuery(value, i)"
          >
            {{ value.name }}
          </b-tag>
        </b-field>
      </div>
    </section>

    <b-table
      v-if="!isFilterLoading"
      class="app-table"
      mobile-cards
      paginated
      detailed
      :checkable="isManagement"
      :checked-rows.sync="checkedRows"
      :per-page="filterPerPage"
      :data="filteredApplications"
      :row-class="(row) => getRowClass(row, true)"
      detail-key="id"
      show-detail-icon
      sticky-header
    >
      <b-progress
        v-if="numberOfStudentsFiltered.show"
        :value="getNumberOfFilteredStudents"
        size="is-medium"
        type="is-success"
        class="my-4"
        show-value
      >
        {{ numberOfStudentsFiltered.filtered }} of
        {{ numberOfStudentsFiltered.initial }} applications being displayed
      </b-progress>
      <b-table-column v-slot="props" field="actions" label="Actions" width="60">
        <div class="app-table__actions">
          <b-button
            tag="router-link"
            :to="{
              name: 'view-student',
              params: {
                id: props.row.studentId,
                applicationId: props.row.id,
                routeIsEdit: false,
              },
            }"
            type="is-success"
          >
            View
          </b-button>
          <b-button @click="showUpdates(props.row)" type="is-info">
            Messages
          </b-button>
          <b-button
            v-if="hasEditingRole || !props.row.isApproved || !props.row.isDraft"
            :disabled="
              !shouldSeeApprove && !props.row.isApproved && !props.row.isDraft
            "
            tag="router-link"
            :to="{
              name: 'edit-student',
              params: {
                id: props.row.studentId,
                applicationId: props.row.id,
                routeIsEdit: true,
              },
            }"
            :type="props.row.isApproved ? 'is-warning' : 'is-danger'"
            style="margin-top: 20px"
          >
            {{
              props.row.isApproved && !props.row.isDraft
                ? 'Edit'
                : !props.row.isApproved && !props.row.isDraft
                ? 'App needs approval'
                : 'Draft app'
            }}
          </b-button>
          <b-button
            v-if="isAdmin || props.row.isDraft || !props.row.isApproved"
            @click="deleteApplication(props.row.id)"
            type="is-danger"
            style="margin-top: 12px"
            >Delete</b-button
          >
        </div>
      </b-table-column>
      <b-table-column field="name" label="Name" width="40" v-slot="props">
        <span :class="{ 'invalid-student': !props.row.studentApproved }">
          {{
            props.row.studentData.personalInformation
              ? props.row.studentData.personalInformation.student_name
              : 'N/A'
          }}
        </span>
      </b-table-column>
      <b-table-column
        field="student_id"
        label="⁠Student ID"
        width="40"
        v-slot="props"
      >
        <div v-if="displayCellEdit(props.row.id, 'studentId')">
          <edit-application-cell
            :editCell="editCell"
            @changedEditCellValue="changedEditCellValue"
          ></edit-application-cell>
        </div>
        <div v-else class="edit-cell">
          <b-icon
            v-if="hasEditingRole"
            class="edit-cell__icon"
            icon="pen"
            type="is-danger"
            size="is-small"
            @click.native.prevent="
              toggleEditCell(
                props.row,
                'studentData.generalInfo.studentId',
                props.row.studentData.generalInfo.studentId
              )
            "
          >
          </b-icon>
          <span class="edit-cell__text">
            {{
              props.row.studentData.generalInfo
                ? props.row.studentData.generalInfo.studentId
                : 'N/A'
            }}
          </span>
        </div>
      </b-table-column>
      <b-table-column
        field="phone_number"
        label="Phone number"
        width="40"
        v-slot="props"
      >
        {{
          props.row.studentData.personalInformation
            ? props.row.studentData.personalInformation.phone_number
            : 'N/A'
        }}
      </b-table-column>
      <b-table-column
        field="email"
        label="Email address"
        width="0"
        v-slot="props"
      >
        {{
          props.row.studentData.personalInformation
            ? props.row.studentData.personalInformation.email
            : 'N/A'
        }}
      </b-table-column>
      <b-table-column
        field="university"
        label="University"
        width="40"
        v-slot="props"
      >
        {{ props.row.university.title }}
      </b-table-column>
      <b-table-column field="campus" label="Campus" width="40" v-slot="props">
        {{ getCity(props.row.university.address) }}
      </b-table-column>
      <b-table-column
        field="course_name"
        label="Course name"
        width="40"
        v-slot="props"
      >
        <span class="cut-title" :title="props.row.courseTitle">{{
          props.row.courseTitle
        }}</span>
      </b-table-column>
      <b-table-column
        field="delivery_mode"
        label="Delivery mode"
        v-slot="props"
        width="60"
      >
        <span
          class="cut-title"
          :title="
            props.row.studentData.personalInformation
              ? props.row.studentData.personalInformation.delivery_mode
              : 'N/A'
          "
          >{{
            props.row.studentData.personalInformation
              ? props.row.studentData.personalInformation.delivery_mode
              : 'N/A'
          }}</span
        >
      </b-table-column>
      <b-table-column field="Agent" label="Agent" width="40" v-slot="props">
        <span :class="{ 'strike-through': props.row.moderatorDeleted }">{{
          props.row.moderator
        }}</span>
      </b-table-column>
      <b-table-column
        field="interview"
        label="Interview"
        width="40"
        v-slot="props"
      >
        <div :class="getCellClass(props.row.studentData.generalInfo.interview)">
          <div v-if="displayCellEdit(props.row.id, 'interview')">
            <edit-application-cell
              :editCell="editCell"
              @changedEditCellValue="changedEditCellValue"
            ></edit-application-cell>
          </div>
          <div v-else class="edit-cell">
            <b-icon
              v-if="hasEditingRole"
              class="edit-cell__icon"
              icon="pen"
              type="is-danger"
              size="is-small"
              @click.native.prevent="
                toggleEditCell(
                  props.row,
                  'studentData.generalInfo.interview',
                  props.row.studentData.generalInfo.interview
                )
              "
            >
            </b-icon>
            <span class="edit-cell__text">
              {{
                props.row.studentData.generalInfo
                  ? props.row.studentData.generalInfo.interview
                  : 'N/A'
              }}
            </span>
          </div>
        </div>
      </b-table-column>
      <b-table-column
        field="english_test"
        label="English test"
        width="40"
        v-slot="props"
      >
        <div
          :class="getCellClass(props.row.studentData.generalInfo.english_test)"
        >
          <div v-if="displayCellEdit(props.row.id, 'english_test')">
            <edit-application-cell
              :editCell="editCell"
              @changedEditCellValue="changedEditCellValue"
            ></edit-application-cell>
          </div>
          <div v-else class="edit-cell">
            <b-icon
              v-if="hasEditingRole"
              class="edit-cell__icon"
              icon="pen"
              type="is-danger"
              size="is-small"
              @click.native.prevent="
                toggleEditCell(
                  props.row,
                  'studentData.generalInfo.english_test',
                  props.row.studentData.generalInfo.english_test
                )
              "
            >
            </b-icon>
            <span class="edit-cell__text">
              {{
                props.row.studentData.generalInfo
                  ? props.row.studentData.generalInfo.english_test
                  : 'N/A'
              }}
            </span>
          </div>
        </div>
      </b-table-column>
      <b-table-column field="status" label="Status" width="40" v-slot="props">
        <div v-if="displayCellEdit(props.row.id, 'status')">
          <edit-application-cell
            :editCell="editCell"
            @changedEditCellValue="changedEditCellValue"
          ></edit-application-cell>
        </div>
        <div v-else class="edit-cell">
          <b-icon
            v-if="hasEditingRole"
            class="edit-cell__icon"
            icon="pen"
            type="is-danger"
            size="is-small"
            @click.native.prevent="
              toggleEditCell(props.row, 'status', props.row.status)
            "
          >
          </b-icon>
          <span class="edit-cell__text">
            {{ props.row.status }}
          </span>
        </div>
      </b-table-column>
      <b-table-column field="booking" label="Updates" width="40" v-slot="props">
        <div v-if="displayCellEdit(props.row.id, 'booking')">
          <edit-application-cell
            :editCell="editCell"
            @changedEditCellValue="changedEditCellValue"
          ></edit-application-cell>
        </div>
        <div v-else class="edit-cell">
          <b-icon
            v-if="hasEditingRole"
            class="edit-cell__icon"
            icon="pen"
            type="is-danger"
            size="is-small"
            @click.native.prevent="
              toggleEditCell(
                props.row,
                'studentData.generalInfo.booking',
                props.row.studentData.generalInfo.booking
              )
            "
          >
          </b-icon>
          <span class="edit-cell__text">
            {{
              props.row.studentData.generalInfo
                ? props.row.studentData.generalInfo.booking
                : 'N/A'
            }}
          </span>
        </div>
      </b-table-column>
      <b-table-column field="intake" label="Intake" v-slot="props" width="60">
        {{
          props.row.studentData.personalInformation
            ? props.row.studentData.personalInformation.intake
            : 'N/A'
        }}
      </b-table-column>
      <b-table-column
        field="Deadline"
        label="Deadline"
        width="40"
        v-slot="props"
      >
        <span>{{ props.row.courseData.deadline }}</span>
      </b-table-column>
      <b-table-column field="SFE" label="SFE" v-slot="props" width="60">
        <div v-if="displayCellEdit(props.row.id, 'student_finance')">
          <edit-application-cell
            :editCell="editCell"
            @changedEditCellValue="changedEditCellValue"
          ></edit-application-cell>
        </div>
        <div v-else class="edit-cell">
          <b-icon
            v-if="hasEditingRole"
            class="edit-cell__icon"
            icon="pen"
            type="is-danger"
            size="is-small"
            @click.native.prevent="
              toggleEditCell(
                props.row,
                'studentData.generalInfo.student_finance'
              )
            "
          >
          </b-icon>
          <span class="edit-cell__text">
            {{
              props.row.studentData.generalInfo
                ? props.row.studentData.generalInfo.student_finance
                : 'N/A'
            }}
          </span>
        </div>
      </b-table-column>
      <b-table-column
        field="team"
        label="Advisor team"
        width="40"
        v-slot="props"
      >
        {{ getAdvisorTeam(props.row.team) }}
      </b-table-column>
      <b-table-column
        field="messages"
        label="Important Dates"
        width="140"
        v-slot="props"
      >
        <p class="text-one-row">
          <b>Created at:</b> {{ props.row.tableDate.createdAt }}
        </p>
        <p v-if="props.row.tableDate.submittedAt" class="text-one-row">
          <b>Submited at:</b> {{ props.row.tableDate.submittedAt }}
        </p>
        <p v-if="props.row.tableDate.approvedAt" class="text-one-row">
          <b>Approved at:</b> {{ props.row.tableDate.approvedAt }}
        </p>
      </b-table-column>

      <template #detail="props">
        <div class="content columns">
          <div class="column is-full">
            <p>Voucher: {{ props.row.studentData.generalInfo.voucher }}</p>
          </div>
          <div
            v-if="
              props.row.studentData.generalInfo.comments &&
              hasEditingRole &&
              props.row.studentData.generalInfo.comments.length
            "
            class="column is-full"
          >
            <p>Comments: {{ props.row.studentData.generalInfo.comments }}</p>
          </div>
        </div>
      </template>
    </b-table>

    <b-loading
      is-full-page
      v-model="isFilterLoading"
      :can-cancel="false"
    ></b-loading>

    <b-modal
      v-model="isMessageModalActive"
      v-if="getActiveConversation.id"
      class="message-modal__app"
    >
      <student-message />
    </b-modal>

    <b-modal
      v-model="isViewStudentModalActive"
      full-screen
      class="message-modal__app"
      @close="$router.push('/applications')"
    >
      <router-view></router-view>
    </b-modal>

    <b-modal
      v-model="dateRange.isActive"
      aria-modal
      has-modal-card
      trap-focus
      aria-role="dialog"
    >
      <b-field label="Select a date">
        <b-datepicker
          placeholder="Click to select..."
          v-model="dateRangeDates"
          @range-end="selectedDateRange"
          range
        >
        </b-datepicker>
      </b-field>
    </b-modal>

    <b-modal v-model="isStudentAdvisorChangeModalActive" :width="800">
      <b-field
        label="Change application student advisor"
        class="column is-full"
      >
        <!-- <b-autocomplete name="team_leader" required placeholder="Choose from the list or type name" open-on-focus v-model="studentAdvisorName" :data="filteredUsers" icon="magnify" clearable @select="option => studentAdvisorName = option">
                <template #empty>No results found</template>
            </b-autocomplete> -->
        <multiselect
          v-model="studentAdvisorName"
          :options="filteredUsers"
          track-by="value"
          label="value"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="true"
          :preserve-search="true"
          placeholder="Choose from the list or type name"
          :preselect-first="false"
        >
        </multiselect>
        <b-button
          @click="saveModeratorId()"
          type="is-primary"
          class="status-btn"
          >Save</b-button
        >
      </b-field>
    </b-modal>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import StudentService from '../services/student.service';
import UtilService from '../services/util';

import StudentMessage from './messaging/StudentMessage.vue';
import EditApplicationCell from './moderator/EditApplicationCell.vue';
import FilterService from '../services/filter';
import moment from 'moment';
import {
  statusOptionsClasses,
  passingOptionsClasses,
  studentMessageMapClass,
  studentMessageStatusMap,
} from '../models/static';
import adminService from '../services/admin.service';
import StudentLoader from './helpers/StudentLoader.vue';

export default {
  name: 'application-list',
  components: {
    StudentMessage,
    EditApplicationCell,
    Multiselect,
    StudentLoader,
  },
  data() {
    return {
      adminHref:
        process.env.VUE_APP_BASE_URL + '/api/admin/generateBackupExcel',
      application: {},
      savedQueries: [],
      checkedRows: [],
      isMessageModalActive: false,
      isStudentAdvisorChangeModalActive: false,
      studentAdvisorName: '',
      isViewStudentModalActive: false,
      selectedQueryName: null,
      oldStudentIntake: null,
      filterApplicationsOpen: false,
      dateRange: {
        isActive: false,
        type: null,
      },
      dateRangeDates: [],
      filterPerPageOptions: [
        {
          name: '25',
          value: 25,
        },
        {
          name: '50',
          value: 50,
        },
        {
          name: '100',
          value: 100,
        },
        {
          name: 'All',
          value: 100000,
        },
      ],
    };
  },
  created() {
    this.getPreviousQueries();
    this.savePrefferedQuery(null, false);

    this.filterApplicationsOpen = localStorage.getItem('filterApplicationsOpen')
      ? localStorage.getItem('filterApplicationsOpen') === 'true'
      : false;
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.isViewStudentModalActive = newVal.meta && newVal.meta.showModal;
      },
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    filteredApplications() {
      return FilterService.queryFilters(
        this.$store.state.application.applications,
        false
      );
    },
    editCell() {
      return this.$store.state.application.editCell;
    },
    filter: {
      get() {
        return this.$store.state.application_filter.filter;
      },
      set() {},
    },
    filterPerPage: {
      get() {
        return this.$store.state.application_filter.filterPerPage;
      },
      set(value) {
        this.$store.dispatch('application_filter/setFilterPerPage', value);
      },
    },
    filteredAddressArray() {
      if (!this.filter.university || !this.filter.university.length) {
        return [...this.filterOptions.universities];
      }

      return [...this.filterOptions.universities].filter((option) => {
        return this.filter.university.some((docFilter) => {
          return (
            docFilter.title.toString().toLowerCase() ===
            option.title.toString().toLowerCase()
          );
        });
      });
    },
    isAdmin() {
      return UtilService.isAdmin();
    },
    isManagement() {
      return UtilService.isManagement();
    },
    getActiveConversation() {
      return UtilService.getActiveConversation();
    },
    getNumberOfFilteredStudents() {
      return (
        (this.numberOfStudentsFiltered.filtered /
          this.numberOfStudentsFiltered.initial) *
        100
      );
    },
    numberOfStudentsFiltered() {
      return {
        show: true,
        initial: this.$store.state.application.applications.length,
        filtered: this.filteredApplications.length,
      };
    },
    shouldSeeApprove() {
      return UtilService.isTeamLeader() || UtilService.isAdmin();
    },
    hasEditingRole() {
      return this.isManagement;
    },
    filterOptions() {
      const currentOptions = UtilService.deepCopy(
        this.$store.state.application_filter.filterOptions
      );
      return currentOptions && Object.keys(currentOptions)
        ? currentOptions
        : {};
    },
    originalUniversities() {
      return this.$store.state.application_filter.filterOptions.universities;
    },
    isFilterLoading() {
      return this.$store.state.application_filter.isFilterLoading;
    },
    changeStudentIntakeOptions() {
      return [...this.filterOptions.intake].filter(
        (intake) => intake.value !== 'None'
      );
    },

    filteredUsers() {
      return UtilService.mappedUsernames().map((user) => {
        return {
          value: user,
        };
      });
    },

    shouldFetchMoreRecords() {
      return (
        this.$store.state.application.offset <
        this.$store.state.application.totalNoApplcations
      );
    },
  },
  methods: {
    isTagSelected(optionName) {
      return this.selectedQueryName === optionName
        ? 'is-success'
        : 'is-primary';
    },

    getCity(address) {
      return address.substring(0, address.indexOf('-'));
    },

    deleteApplication(id) {
      this.$buefy.dialog.confirm({
        message:
          'Are you sure you want to delete application? This action cannot be undone',
        onConfirm: () => {
          StudentService.deleteApplication(id).then(() => {
            this.$store.dispatch('application/deleteApplication', id);

            this.$buefy.toast.open({
              duration: 3000,
              message: `Application succesfully deleted`,
              position: 'is-bottom',
              type: 'is-success',
            });
          });
        },
      });
    },

    toggleFilterApplications(value) {
      localStorage.setItem('filterApplicationsOpen', value);
    },

    addTagUniversityAdress(newTag) {
      this.$store.dispatch('application_filter/addUniversityFilter', {
        address: newTag,
        title: newTag,
        type: 'address',
      });
    },

    addTagUniversityTitle(newTag) {
      this.$store.dispatch('application_filter/addUniversityFilter', {
        address: newTag,
        title: newTag,
        type: 'title',
      });
    },

    addTagStudent(newTag) {
      this.$store.dispatch('application_filter/addCustomTag', {
        value: newTag,
        type: 'student',
      });
    },

    addTagCourse(newTag) {
      this.$store.dispatch('application_filter/addCustomTag', {
        value: newTag,
        type: 'course',
      });
    },

    setStudentIntake() {
      adminService.setStudentIntake().then(() => {
        this.$buefy.toast.open({
          duration: 3000,
          message: `Sets the initial student intake`,
          position: 'is-bottom',
          type: 'is-success',
        });
      });
    },

    checkIfCustom(objectValue, type) {
      const valueToCheck = 'Custom';
      if (objectValue.value === valueToCheck) {
        this.filter[type] = this.filter[type].filter(
          (item) => item.value !== valueToCheck
        );
        this.dateRange = {
          isActive: true,
          type,
        };
      }
    },

    selectedDateRange() {
      setTimeout(() => {
        this.filter[this.dateRange.type].push({
          value: `Custom - ${moment(this.dateRangeDates[0]).format(
            'LLL'
          )} - ${moment(this.dateRangeDates[1]).format('LLL')}`,
        });
        this.dateRange = {
          isActive: false,
          type: null,
        };
        this.dateRangeDates = [];
      }, 100);
    },

    getRowClass(row, isObject) {
      let rowClass;

      if (row.isApproved || !isObject) {
        const statusToCheck = isObject ? row.status : row;
        const rowStatus =
          statusToCheck && !statusOptionsClasses[statusToCheck]
            ? 'status-nude'
            : statusOptionsClasses[statusToCheck];
        rowClass = isObject
          ? `app-table__row ${rowStatus}`
          : `multiselect__tag status-tag ${rowStatus}`;
      } else if (isObject && row.isDraft) {
        rowClass += 'app-table__row is_draft';
      } else {
        rowClass += `app-table__row status-not-approved`;
      }

      if (!row.isAdminApproved) {
        rowClass += ' moderator-not-approved';
      }

      return {
        [rowClass]: true,
      };
    },

    getCellClass(cell) {
      if (!cell || !cell.length) {
        return '';
      }

      const cellClass = !passingOptionsClasses[cell]
        ? 'status-booked'
        : passingOptionsClasses[cell];
      return `fake-bg-cell ${cellClass}`;
    },

    messageStatus(status) {
      return status === 'Resolved' ? 'is-green' : '';
    },

    mapStudentDataForCSV(applications) {
      return applications.map((app) => {
        return {
          Name: app.studentData.personalInformation.student_name,
          'Student ID': app.studentData.generalInfo.studentId,
          'Phone number': app.studentData.personalInformation.phone_number,
          'Email address': app.studentData.personalInformation.email,
          University: app.university.title,
          Campus: this.getCity(app.university.address),
          'Course name': app.courseTitle,
          'Delivery mode': app.studentData.personalInformation.delivery_mode,
          Agent: app.moderator,
          Booking: app.studentData.generalInfo.booking,
          'English test': app.studentData.generalInfo.english_test,
          Status: app.status,
          Intake: app.studentData.personalInformation.intake,
          SFE: app.studentData.generalInfo.student_finance,
          'Advisor team': this.getAdvisorTeam(app.team),
          'Created at': this.formatDate(app.date),
        };
      });
    },

    downloadLocalData() {
      const mappedData = UtilService.arrayToCsv(
        this.mapStudentDataForCSV(this.filteredApplications)
      );
      const fileName = `student_data_${this.formatDate(new Date())}.csv`;
      UtilService.downloadBlob(mappedData, fileName, 'text/csv;charset=utf-8;');
    },

    downloadData() {
      adminService.generateSecureCache().then((response) => {
        const queryId = response.data.unique_id;
        window
          .open(
            `${this.adminHref}?queryId=${queryId}&moderatorId=${this.currentUser.id}`,
            '_blank'
          )
          .focus();
      });
    },

    queryUniversities(queryString) {
      this.filterOptions.universities = queryString.length
        ? [...this.originalUniversities].filter(
            (university) =>
              university.title
                .toLowerCase()
                .includes(queryString.toLowerCase()) ||
              university.address
                .toLowerCase()
                .includes(queryString.toLowerCase())
          )
        : this.originalUniversities;
    },

    generateFilterArray(data) {
      return [...new Set(data)]
        .filter((x) => x)
        .map((status) => {
          return {
            value: status,
          };
        });
    },

    resetQuery() {
      this.$store.dispatch('application_filter/resetFilterData');
      this.savePrefferedQuery(null, true);
      this.$store.dispatch('application/toggleEditCell', null);
    },

    regenerateFilters() {
      this.$store.dispatch('application_filter/setInitialFilters', {
        apps: FilterService.queryFilters(
          this.$store.state.application.applications
        ),
        universities: this.originalUniversities,
        finishedLoading: true,
      });
    },

    moveStudentsToOldIntake() {
      if (!this.checkedRows.length) {
        this.$buefy.toast.open({
          duration: 3000,
          position: 'is-bottom',
          message: 'Need to select at least one student',
          type: 'is-danger',
        });
      } else {
        const intake = this.oldStudentIntake;

        const mappedIds = this.checkedRows.map((row) => {
          return {
            id: row.studentId,
            intake,
          };
        });

        StudentService.moveStudentsOld(mappedIds).then(() => {
          this.checkedRows.map((row) => {
            this.toggleEditCell(
              row,
              'studentData.personalInformation.intake',
              this.oldStudentIntake
            );
          });

          this.checkedRows = [];

          this.$buefy.toast.open({
            duration: 3000,
            message: `Students moved to intake ${this.oldStudentIntake}`,
            position: 'is-bottom',
            type: 'is-success',
          });
        });
      }
    },

    dateCheck(from, to, check) {
      return (
        Date.parse(check) <= Date.parse(to) &&
        Date.parse(check) >= Date.parse(from)
      );
    },

    showUpdates(application) {
      this.application = {
        id: application.id,
        messages: application.application_messages,
        studentId: application.studentId,
        courseDocuments: application.courseDocuments,
      };

      this.$store.dispatch('application/setActiveConversation', {
        id: application.id,
        studentId: application.studentId,
        courseDocuments: application.courseData.documents,
        studentName: application.studentData.personalInformation.student_name,
        courseTitle: application.courseTitle,
        moderatorId: application.moderatorId,
        isApproved: application.isApproved,
      });

      this.isMessageModalActive = true;
    },

    toggleEditCell(studentValue, path, value, setData = false) {
      this.$store.dispatch('application/toggleEditCell', {
        studentValue,
        path,
        value,
        setData,
      });
    },

    changedEditCellValue(editCell) {
      this.$store.dispatch('application/toggleEditCell', null);
      if (!editCell) {
        return;
      }
      const currentApp = this.filteredApplications.filter(
        (app) => app.id === editCell.id
      )[0];

      this.toggleEditCell(currentApp, editCell.path, editCell.value);
      const updateCellPayload =
        editCell.path === 'status'
          ? {
              id: editCell.id,
              status: editCell.value,
            }
          : {
              id: editCell.studentId,
              path: editCell.path,
              value: editCell.value,
              course: currentApp.courseTitle,
              university: `${currentApp.university.title} - ${currentApp.university.address}`,
            };

      this.$eventHub.$emit('socket__event', {
        messageType: 'socket__edit-application',
        messageValue: {
          path: editCell.path,
          studentValue: editCell.id,
          value: editCell.value,
          setData: true,
        },
      });

      if (editCell.path === 'status') {
        StudentService.updateStatus(updateCellPayload).then(() => {
          this.$buefy.toast.open({
            duration: 3000,
            message: `Status updated succesfully`,
            position: 'is-bottom',
            type: 'is-success',
          });
        });
      } else {
        StudentService.updateStudentCell(updateCellPayload).then(() => {
          this.$buefy.toast.open({
            duration: 3000,
            message: `Succesfully updated cell value`,
            position: 'is-bottom',
            type: 'is-success',
          });
        });
      }

      this.$store.dispatch('application/toggleEditCell', null);
    },

    displayCellEdit(id, fieldName) {
      return (
        this.editCell.id &&
        this.editCell.id === id &&
        this.editCell.fieldName === fieldName
      );
    },

    getUCBackground(status) {
      return studentMessageMapClass[status];
    },

    getUCText(text) {
      const foundText = studentMessageStatusMap.filter(
        (status) => status.id === text
      );
      return foundText && foundText.length ? foundText[0].value : text;
    },

    getAdvisorTeam(team) {
      if (team.teamId && this.filterOptions.teams.length) {
        const foundTeam = this.filterOptions.teams.filter(
          (teams) => teams.teamId === team.teamId
        );
        if (foundTeam.length) {
          return this.parseTeam(foundTeam[0]);
        }
      }

      return '';
    },

    parseTeam(value) {
      return value.teamName + ' - ' + value.username;
    },

    saveQuery() {
      this.$buefy.dialog.prompt({
        message: `Give this query a name to identify it easier`,
        inputAttrs: {
          placeholder: 'e.g. Students with warning',
          minlength: 5,
        },
        trapFocus: true,
        onConfirm: (name) => {
          let appQueries = JSON.parse(
            localStorage.getItem('appQueries') || '[]'
          );
          appQueries.push({
            name,
            filters: this.filter,
          });

          this.savePrefferedQuery(name, true);

          localStorage.setItem('appQueries', JSON.stringify(appQueries));
          this.getPreviousQueries();
        },
      });
    },

    getPreviousQueries() {
      this.savedQueries = JSON.parse(
        localStorage.getItem('appQueries') || '[]'
      );
    },

    setSavedFilter(filterData) {
      this.$store.dispatch(
        'application_filter/setFilterData',
        filterData.filters
      );
      this.savePrefferedQuery(filterData.name, true);
    },

    savePrefferedQuery(name, shouldSet) {
      if (shouldSet) {
        localStorage.setItem('prefferedQuery', name);
        this.selectedQueryName = name;
      } else {
        const prevQuery = localStorage.getItem('prefferedQuery');
        if (prevQuery) {
          this.selectedQueryName = prevQuery;
          const prefferedFilter = UtilService.deepCopy(
            this.savedQueries
          ).filter((query) => query.name === prevQuery);
          setTimeout(() => {
            if (prefferedFilter && prefferedFilter.length) {
              this.$store.dispatch(
                'application_filter/setFilterData',
                prefferedFilter[0].filters
              );
            }
          }, 100);
        }
      }
    },

    deleteSavedQuery(filter, index) {
      this.$buefy.dialog.confirm({
        message:
          'Are you sure you want to delete this query? This action cannot be undone',
        onConfirm: () => {
          this.savedQueries.splice(index, 1);
          localStorage.setItem('appQueries', JSON.stringify(this.savedQueries));
          this.getPreviousQueries();
        },
      });
    },

    formatDate(dateString) {
      return new Intl.DateTimeFormat('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(new Date(dateString));
    },

    saveModeratorIdOld() {
      const moderatorName = this.studentAdvisorName.value;
      const studentAdvisor = this.$store.state.users.users.filter(
        (leader) => leader.username === moderatorName
      );
      for (let index = 0; index < this.checkedRows.length; index++) {
        const application = this.checkedRows[index];
        if (studentAdvisor.length) {
          const moderatorId = studentAdvisor[0].id;

          let {
            documents = null,
            id = null,
            ...studentCopy
          } = application.studentData;

          studentCopy.moderatorId = moderatorId;

          let newS = documents;
          newS = null;
          let formData = new FormData();
          formData.append('templateOptions', JSON.stringify(studentCopy));
          formData.append('id', application.studentId);
          formData.append('newS', newS);
          formData.append('docModeratorName', this.currentUser.username);

          StudentService.create(formData).then(() => {
            StudentService.updateStudentAdvisor({
              studentId: application.studentId,
              moderatorId: moderatorId,
            }).then(() => {
              this.$eventHub.$emit('socket__event', {
                messageType: 'socket__edit-application',
                messageValue: {
                  path: 'moderator',
                  studentValue: application.id,
                  value: moderatorName,
                  setData: true,
                },
              });
              this.$buefy.toast.open({
                duration: 3000,
                message: 'Student advisor was changed succesfully',
                position: 'is-bottom',
                type: 'is-success',
              });
            });
          });
        }
      }

      this.isStudentAdvisorChangeModalActive = false;
    },

    saveModeratorId() {
      const moderatorName = this.studentAdvisorName.value;
      const studentAdvisor = this.$store.state.users.users.filter(
        (leader) => leader.username === moderatorName
      );
      for (let index = 0; index < this.checkedRows.length; index++) {
        const application = this.checkedRows[index];

        if (studentAdvisor.length) {
        const moderatorId = studentAdvisor[0].id;

        StudentService.updateStudentAdvisor({
          studentId: application.studentId,
          moderatorId: moderatorId,
          applicationId: application.id,
        }).then(() => {
          this.$buefy.toast.open({
            duration: 3000,
            message:
              'Student advisor was changed succesfully, please refresh to see the changes',
            position: 'is-bottom',
            type: 'is-success',
          });
        });
      }
      }
      
    }
  },
};
</script>

<style>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.card-content.filter-columns {
  width: 100%;
}

.space-between.dropdown-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 6px;
}

.app-table .top.level {
  display: block;
}

.app-table__actions {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  min-width: 180px;
  justify-content: space-between;
  align-items: flex-end;
}

.multiselect__tag.status-tag,
.multiselect__tag.status-tag.status-nude {
  color: #363636;
}

.cut-title {
  display: -webkit-box;
  max-width: 200px;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.table td {
  position: relative;
}

.edit-cell {
  display: flex;
  min-height: 24px;
  justify-content: flex-start;
  align-items: center;
}

.edit-cell__icon {
  cursor: pointer;
  margin-right: 4px;
}

.text-one-row {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fake-bg-cell {
  padding: 0.5em 0.75em;
  border-radius: 12px;
}

.app-table__row {
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.uc-app-cell {
  /* width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0; */
  color: white;
  padding: 8px;
  text-align: center;
}

.invalid-student {
  color: red;
}

.moderator-not-approved {
  color: blue;
}

/* .uc-app-cell > span {
    -webkit-writing-mode: vertical-rl;
    writing-mode: vertical-r1;
    transform: rotate(180deg);
    text-align: center;
} */
</style>
